export class OverrideParseResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fieldPath",
            "baseName": "fieldPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetType",
            "baseName": "targetType",
            "type": "FieldOverrideTargetType",
            "format": ""
        },
        {
            "name": "parseFormat",
            "baseName": "parseFormat",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampled",
            "baseName": "sampled",
            "type": "number",
            "format": ""
        },
        {
            "name": "parsedCount",
            "baseName": "parsedCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "parseSuccessRate",
            "baseName": "parseSuccessRate",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampleExamples",
            "baseName": "sampleExamples",
            "type": "Array<OverrideSampleExample>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideParseResult.attributeTypeMap;
    }
    constructor() {
    }
}
